module.exports = __webpack_public_path__ + "logo.svg?c303d11aeb781adc966ea6c96c8fc350";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 261
// module chunks = 0